import React from 'react';
import PropTypes from 'prop-types';

import Fees from './Fees';
import { MoneyFitSmall } from './MoneyFit';
import TaxBreakdown from './TaxBreakdown';
import { taxBreakdownArray } from '../shapes';

const TotalCollected = ({ netSales, taxes, tips, fees, totalCollected, loanRepayment, showTips, taxBreakdown }) => (
  <div className="c-report-total-calculation small-pt">
    <div className="c-report-total-calculation__cell">
      <div className="c-report-label">Net Sales</div>
      <div className="c-report-stat c-report-stat--small u-type--normal">
        <MoneyFitSmall automationId="text:totalCollected:netSalesAmount">{netSales}</MoneyFitSmall>
      </div>
    </div>
    <div className="c-report-total-calculation__cell" display-if={loanRepayment > 0}>
      <div className="c-report-stat c-report-stat--small u-co-gray-1 u-pv">-</div>
    </div>
    <div className="c-report-total-calculation__cell" display-if={loanRepayment > 0}>
      <div className="c-report-label">Financing</div>
      <div className="c-report-stat c-report-stat--small u-type--normal">
        <MoneyFitSmall automationId="text:totalCollected:loanRepaymentAmount">{loanRepayment}</MoneyFitSmall>
      </div>
    </div>
    <div className="c-report-total-calculation__cell">
      <div className="c-report-stat c-report-stat--small u-co-gray-1 u-pv">+</div>
    </div>
    <div className="c-report-total-calculation__cell">
      <div className="c-report-label">Taxes</div>
      <div className="c-report-stat c-report-stat--small u-type--normal">
        <TaxBreakdown amount={taxes} breakdown={taxBreakdown} />
      </div>
    </div>
    <div className="c-report-total-calculation__cell" display-if={showTips}>
      <div className="c-report-stat c-report-stat--small u-co-gray-1 u-pv">+</div>
    </div>
    <div className="c-report-total-calculation__cell" display-if={showTips}>
      <div className="c-report-label">Tips</div>
      <div className="c-report-stat c-report-stat--small u-type--normal">
        <MoneyFitSmall automationId="text:totalCollected:tipsAmount">{tips}</MoneyFitSmall>
      </div>
    </div>
    <div className="c-report-total-calculation__cell">
      <div className="c-report-stat c-report-stat--small u-co-gray-1 u-pv">-</div>
    </div>
    <Fees fees={fees} automationIdPart="totalCollectedFees" />
    <div className="c-report-total-calculation__cell">
      <div className="c-report-stat c-report-stat--small u-co-gray-1 u-pv u-mr+ medium-and-down-mr0">=</div>
    </div>
    <div className="c-report-total-calculation__cell u-bg-primary u-pv+">
      <div className="c-report-label u-co-white">Total Collected</div>
      <div className="c-report-stat c-report-stat--small u-type--normal u-co-white">
        <MoneyFitSmall automationId="text:totalCollected:totalCollectedAmount">{totalCollected}</MoneyFitSmall>
      </div>
    </div>
  </div>
);
TotalCollected.propTypes = {
  netSales: PropTypes.number.isRequired,
  taxes: PropTypes.number.isRequired,
  tips: PropTypes.number.isRequired,
  totalCollected: PropTypes.number.isRequired,
  fees: PropTypes.number.isRequired,
  loanRepayment: PropTypes.number.isRequired,
  showTips: PropTypes.bool,
  taxBreakdown: taxBreakdownArray.isRequired,
};
TotalCollected.defaultProps = {
  showTips: true,
};

export default TotalCollected;
